/*
  Rythmelys, page « Qui sommes-nous » (08/10/2026), maquette version 4 validée par Hamadi (« oui la 4 c'est bon », 21 h 14).
  Anime les blocs rythmelys-table, rythmelys-fil, rythmelys-compteur, rythmelys-symbole,
  la frise (bloc timeline avec la classe « ry-frise ») et les apparitions douces (classe « ry-apparait » sur un bloc).
  GSAP 3.12.5 et ScrollTrigger sont chargés depuis les fichiers du thème, seulement sur la page qui en a besoin.
  Sans GSAP ou en mouvement réduit : tout reste visible, les chiffres sont déjà justes. Documenté dans assets/CUSTOM.txt.
*/
(function () {
  var moi = document.currentScript;
  if (window.RyQsn) return;
  var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editeur = !!(window.Shopify && window.Shopify.designMode);
  window.RyQsn = { calme: calme };

  function pret(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function charge(src) {
    return new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = src;
      s.async = false;
      s.onload = ok;
      s.onerror = ko;
      document.head.appendChild(s);
    });
  }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  // ---------- Le fil de polaroïds (21st.dev id 36189 : ressort amorti, balancement, aimant au centre) ----------
  function fil(racine) {
    var chemin = racine.querySelector('.ryf__ficelle path');
    var cartes = [].slice.call(racine.querySelectorAll('.ryf__pince'));
    var n = cartes.length;
    if (!n || !chemin) return;
    var lg = racine.querySelector('.ryf__legende');
    var cpt = racine.querySelector('.ryf__compte b');
    var tot = racine.querySelector('[data-total]');
    if (tot) tot.textContent = String(n).padStart(2, '0');
    cartes.forEach(function (c, i) { c.dataset.i = i; });
    var S = { off: 0, vel: 0, cible: 0, a: [], w: [] };
    var taille = { w: 1200, h: 600, cw: 240 }, actif = -1, glisse = null, dernierGeste = 0, ecart = 260;
    var SAG = 46;
    function mesure() {
      var r = racine.getBoundingClientRect();
      var cw = Math.round(Math.max(150, Math.min(240, r.width * 0.42, r.height * 0.46)));
      taille = { w: r.width, h: r.height, cw: cw };
      ecart = cw * 1.08;
      racine.style.setProperty('--cw', cw + 'px');
      S.cible = Math.max(actif, 0) * ecart;
      S.off = S.cible;
    }
    if (window.ResizeObserver) new ResizeObserver(mesure).observe(racine);
    mesure();
    function ressort(x, v, t, dt) { var k = 70, c = 2 * Math.sqrt(k); var nv = v + (k * (t - x) - c * v) * dt; return [x + nv * dt, nv]; }
    function balance(a, w, vit, dt, g) { var nw = w + (-38 * a - 4.2 * w + vit * 0.0034 * g) * dt; return [clamp(a + nw * dt, -0.6, 0.6), nw]; }
    function proche(off) { return clamp(Math.round(off / ecart), 0, n - 1); }
    function montre(i) {
      if (i === actif) return;
      actif = i;
      cartes.forEach(function (c, j) { c.dataset.on = j === i ? '1' : '0'; c.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      if (lg) { lg.querySelector('b').textContent = cartes[i].dataset.nom || ''; lg.querySelector('span').textContent = cartes[i].dataset.moment || ''; }
      if (cpt) cpt.textContent = String(i + 1).padStart(2, '0');
    }
    function va(i) { S.cible = clamp(i, 0, n - 1) * ecart; }
    var prec = performance.now(), visible = true, raf = 0;
    function image(t) {
      raf = 0;
      if (!visible) return;
      var dt = Math.min(0.033, (t - prec) / 1000);
      prec = t;
      var w = taille.w, h = taille.h, cw = taille.cw, y0 = Math.max(26, h * 0.07), g = calme ? 0 : 1, vit, i;
      if (glisse && glisse.bouge) vit = glisse.v * 1000;
      else { var avant = S.off, r = ressort(S.off, S.vel, S.cible, dt); S.off = r[0]; S.vel = r[1]; vit = -(S.off - avant) / Math.max(dt, 1e-3); }
      var pr = proche(S.off);
      for (i = 0; i < n; i++) {
        var el = cartes[i], x = w / 2 + i * ecart - S.off;
        if (x < -cw * 1.5 || x > w + cw * 1.5) { el.style.visibility = 'hidden'; continue; }
        el.style.visibility = 'visible';
        var b = balance(S.a[i] || 0, S.w[i] || 0, vit, dt, g), a = b[0];
        if (g) a += Math.sin(t / 1300 + i * 1.7) * 0.0009;
        S.a[i] = a; S.w[i] = b[1];
        var tt = clamp(x / w, 0, 1), y = y0 + 4 * SAG * tt * (1 - tt) - 6;
        el.style.transform = 'translate(' + (x - cw / 2).toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + a.toFixed(4) + 'rad)';
        el.style.zIndex = String(i === pr ? n + 1 : n - Math.abs(i - pr));
      }
      chemin.setAttribute('d', 'M0 ' + y0 + ' Q' + w / 2 + ' ' + (y0 + 2 * SAG) + ' ' + w + ' ' + y0);
      montre(pr);
      raf = requestAnimationFrame(image);
    }
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible && !raf) { prec = performance.now(); raf = requestAnimationFrame(image); }
    }).observe(racine);
    raf = requestAnimationFrame(image);
    if (!calme) setInterval(function () {
      if (document.hidden || glisse || !visible || performance.now() - dernierGeste < 4500) return;
      va(actif >= n - 1 ? 0 : actif + 1);
    }, 4500);
    racine.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.ryf__barre')) return;
      dernierGeste = performance.now();
      glisse = { x: e.clientX, off: S.off, lx: e.clientX, lt: e.timeStamp, v: 0, bouge: false };
    });
    racine.addEventListener('pointermove', function (e) {
      var d = glisse;
      if (!d) return;
      var dx = e.clientX - d.x;
      if (!d.bouge && Math.abs(dx) > 5) { d.bouge = true; racine.dataset.glisse = '1'; try { racine.setPointerCapture(e.pointerId); } catch (x) {} }
      if (!d.bouge) return;
      var dt = Math.max(1, e.timeStamp - d.lt);
      d.v = 0.7 * ((e.clientX - d.lx) / dt) + 0.3 * d.v;
      d.lx = e.clientX; d.lt = e.timeStamp;
      var max = (n - 1) * ecart, off = d.off - dx;
      if (off < 0) off *= 0.35;
      if (off > max) off = max + (off - max) * 0.35;
      S.off = off;
    });
    function lache(e) {
      var d = glisse;
      glisse = null;
      dernierGeste = performance.now();
      if (!d) return;
      if (d.bouge) { racine.dataset.glisse = '0'; S.vel = -d.v * 1000; va(proche(S.off - d.v * 180)); return; }
      var c = e.target.closest('[data-i]');
      if (c) va(+c.dataset.i);
    }
    racine.addEventListener('pointerup', lache);
    racine.addEventListener('pointercancel', lache);
    [].forEach.call(racine.querySelectorAll('[data-pas]'), function (b) {
      b.addEventListener('click', function () { dernierGeste = performance.now(); va(actif + (+b.dataset.pas)); });
    });
    racine.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') va(actif + 1);
      else if (e.key === 'ArrowLeft') va(actif - 1);
      else return;
      dernierGeste = performance.now();
      e.preventDefault();
    });
    // Ordinateur : départ sur la photo réglée (3e par défaut) pour que le fil soit plein des deux côtés ; téléphone : sur la 1re.
    var depart = window.innerWidth > 900 ? clamp(+racine.dataset.depart || 0, 0, n - 1) : 0;
    S.cible = S.off = depart * ecart;
    montre(depart);
  }

  // ---------- Sans mouvement : tout est visible tout de suite ----------
  function sansMouvement() {
    [].forEach.call(document.querySelectorAll('[data-ry-table].ry-attente'), function (t) { t.classList.remove('ry-attente'); });
    [].forEach.call(document.querySelectorAll('.ry-frise .timeline__step'), function (s) { s.classList.add('ry-on'); });
  }

  // ---------- Avec GSAP : la pose, l'écart, les apparitions, les chiffres, le logo, la frise ----------
  function anime() {
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    // 1. La table : les objets se posent un par un, puis s'écartent du carton quand on descend.
    [].forEach.call(document.querySelectorAll('[data-ry-table]'), function (t) {
      var objets = [].slice.call(t.querySelectorAll('.ryt__objet')).filter(function (o) { return o.offsetParent; });
      var dejaVu = t.dataset.vu === '1';
      t.classList.remove('ry-attente');
      if (!dejaVu) {
        gsap.from(objets, {
          y: -140, opacity: 0, scale: 1.12,
          rotation: function (i) { return '+=' + (i % 2 ? 14 : -14); },
          duration: 0.9, ease: 'power3.out', stagger: 0.09, delay: 0.15
        });
      }
      // xPercent et yPercent : séparés du « y » de la pose, pour que les deux mouvements ne se marchent pas dessus.
      objets.forEach(function (o) {
        gsap.to(o, {
          xPercent: (+o.dataset.dx || 0) * 35, yPercent: (+o.dataset.dy || 0) * 45 + 12, ease: 'none',
          scrollTrigger: { trigger: t, start: 'top top', end: 'bottom top', scrub: 0.6 }
        });
      });
    });

    // 2. Apparitions douces.
    gsap.utils.toArray('.ry-apparait').forEach(function (el) {
      gsap.from(el, { y: 28, opacity: 0, duration: 0.8, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    });

    // 3. Les chiffres comptent de 0 jusqu'à leur valeur.
    gsap.utils.toArray('[data-ry-compte]').forEach(function (el) {
      var fin = +el.dataset.ryCompte, o = { v: 0 };
      if (!isFinite(fin)) return;
      el.textContent = '0';
      gsap.to(o, {
        v: fin, duration: 1.6, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 90%', once: true },
        onUpdate: function () { el.textContent = Math.round(o.v); },
        onComplete: function () { el.textContent = fin; }
      });
    });

    // 4. Le symbole du logo se dessine, puis le soleil apparaît.
    gsap.utils.toArray('[data-ry-symbole]').forEach(function (l) {
      var st = { trigger: l, start: 'top 88%', once: true };
      if (l.dataset.dessin === '1') {
        gsap.from(l.querySelectorAll('.rys__cercle, .rys__arc'), { strokeDasharray: 100, strokeDashoffset: 100, duration: 1.2, ease: 'power2.inOut', scrollTrigger: st });
        gsap.from(l.querySelector('.rys__point'), { scale: 0, transformOrigin: '50% 50%', duration: 0.6, delay: 1, ease: 'back.out(2)', scrollTrigger: st });
      } else {
        gsap.from(l.querySelector('.rys__point'), { scale: 0, transformOrigin: '50% 50%', duration: 0.7, ease: 'back.out(2)', scrollTrigger: st });
      }
    });

    // 5. La frise des métiers : les étapes arrivent, le trait se colore au défilement.
    gsap.utils.toArray('.ry-frise').forEach(function (f) {
      var etapes = [].slice.call(f.querySelectorAll('.timeline__step'));
      if (!etapes.length) return;
      gsap.from(etapes, { y: 30, opacity: 0, duration: 0.7, ease: 'power3.out', stagger: 0.15, scrollTrigger: { trigger: f, start: 'top 80%', once: true } });
      var allume = function (p) {
        var k = Math.round(p * (etapes.length - 1));
        etapes.forEach(function (s, i) { s.classList.toggle('ry-on', p > 0.02 && i <= k); });
      };
      window.ScrollTrigger.create({ trigger: f, start: 'top 75%', end: 'bottom 60%', onUpdate: function (s) { allume(s.progress); }, onLeave: function () { allume(1); } });
    });
  }

  pret(function () {
    [].forEach.call(document.querySelectorAll('[data-ry-fil]'), fil);
    if (calme || editeur || !moi || !moi.dataset.gsap) { sansMouvement(); return; }
    charge(moi.dataset.gsap)
      .then(function () { return charge(moi.dataset.st); })
      .then(anime)
      .catch(sansMouvement);
  });
})();
